import React from 'react';
import {observer} from "mobx-react";
import {Translate} from "../util/translation.util";
import {TranslationDomainEnum} from "../../types/enums";
import {HelperService} from "../../service/helper.service";
import styled from "styled-components";

const StyledButtonLink = styled.a`    
  font-size: 14px;
  height: 32px;
  line-height: 24px;
  padding: 4px 15px;
  border-radius: 6px;`

const FoLink: React.FC<{
    className?: string,
    path: string,
    message: string,
    domain?: TranslationDomainEnum
}> = observer(({path, message,className =  'ant-btn ant-btn-secondary', domain = TranslationDomainEnum.MESSAGES}) => {
    return (
        <StyledButtonLink style={{display:"block"}} target='_blank' className={className} href={HelperService.generateFoUrl(path)}>
            <Translate message={message} domain={domain} />
        </StyledButtonLink>
    );
})

export default FoLink;